import { PROCESS } from "@/lib/constants";
import { useInView } from "@/hooks/useInView";

const Step = ({ p, idx, total }) => {
  const { ref, inView } = useInView();
  return (
    <div
      ref={ref}
      data-testid={`process-step-${idx}`}
      className={`relative fade-up ${inView ? "in-view" : ""}`}
      style={{ transitionDelay: `${idx * 120}ms` }}
    >
      <div className="flex items-center gap-4 mb-6">
        <div className="ra-step-num">STEP {p.step}</div>
        <span className="flex-1 h-px bg-[#C5A880]/40" />
      </div>
      <div className="font-heading text-[#0A1128] text-3xl md:text-4xl font-medium leading-tight mb-4">
        {p.title}
      </div>
      <p className="font-body text-[#4B5563] text-[15px] leading-relaxed">
        {p.description}
      </p>
      {idx < total - 1 && (
        <div className="hidden lg:block absolute top-1.5 right-[-32px] w-16 h-px bg-[#C5A880]/30" />
      )}
    </div>
  );
};

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-white py-24 md:py-32"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-3xl mb-16 md:mb-20">
          <div className="ra-eyebrow mb-6">
            <span className="ra-hairline" />
            <span>Our Process</span>
          </div>
          <h2 className="font-heading text-[#0A1128] text-3xl md:text-4xl lg:text-[52px] font-medium leading-[1.08] tracking-tight">
            A Disciplined Path from{" "}
            <span className="text-[#00A859]">Question</span> to{" "}
            <span className="text-[#00A859]">Confidence.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-10">
          {PROCESS.map((p, i) => (
            <Step key={p.step} p={p} idx={i} total={PROCESS.length} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
